/**
 * Activity Item
 *
 * @package lib-components
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

export interface IActivityItem {
	/** Item ID */
	id: string;

	/** Item state */
	state?: ACTIVITY_ITEM_STATE;

	/** Item data */
	data: unknown;
}

export enum ACTIVITY_ITEM_STATE {
	READY = "ready",
	ADDED = "added",
	REMOVED = "removed",
	DEFAULT = READY
}
